import StateContext from './StateContext';

export interface SearchOptions {
  id: string;
  name: string;
  description: string;
}

export interface AppBarContextData {
  title?: string;

  showSearch?: boolean;
  searchOptions?: SearchOptions[];
  showSearchOptions?: boolean;
  updateSearchOn?: 'change' | 'blur' | 'submit';
  searchValue?: string;
}

export const AppBarContext = StateContext<AppBarContextData>([{}, () => {}]);

export default AppBarContext;
